import {
  Component,
  Input,
  Output,
  EventEmitter,
  SimpleChanges,
  ViewChild,
  ElementRef,
} from '@angular/core';
import { Router } from '@angular/router';
import { SnapshotService } from 'src/app/modules/snapshot/Services/snapshot.service';
import { SharedPopupService } from 'src/app/common/services/shared-popup.service';
import { CustomsnapshotService } from 'src/app/modules/snapshot/Services/customsnapshot.service';

interface Client {
  ClientName: string;
  showStudies: boolean;
  UniqueStudies: string[];
}

@Component({
  selector: 'app-snapshot-landing-container',
  templateUrl: './snapshot-landing-container.component.html',
  styleUrls: ['./snapshot-landing-container.component.css']
})
export class SnapshotLandingContainerComponent {
  StudyNames: any[] = ["dhdhdh", 'dddddd', 'hdhhdhdhd'];
  studydropdown: boolean = false;
  Acrossdropdowncheck: boolean = false;
  @Input() configData: any;
  studyname: any = "study Name";
  Acrossname: any = "compare Across";
  @Input() studyNames: any;
  @Input() ClientName: any;
  @Input() isSuperAdmin: any;
  filteredData: any[] = [];
  popUpData: any;
  AcrossDropdown: any;
  studyNamesCount: any = 0;
  studtNamesArray: any;
  snapshotselected: any = "";
  sectionSelected: any = "";
  subsectinselected: any = "";

  constructor(private router: Router, private _configService: SnapshotService, public SharedPopupService: SharedPopupService, private _configCustomService: CustomsnapshotService) { }

  ngOnInit() {
    this.getPopUpeData();
    this.toggleStudies(this.ClientName);
    if (this.isSuperAdmin) {
      this.studyNamesCount = this.studyNames.UniqueSnapshots.length;
      this.studtNamesArray = this.studyNames.UniqueSnapshots;
    }
    else {
      this.studyNamesCount = this.studyNames.UniqueStudies.length;
      this.studtNamesArray = this.studyNames.UniqueStudies;
    }
  }

  getPopUpeData(): void {
    this.SharedPopupService.setPopUpTabData$.subscribe((data) => {
      if (data != null && data.data.length > 0) {
        //data=this.restrictClientsBasedOnEmailID(data);
        this.popUpData = data.data;
        //this.moduleName = data.moduleName
        this.filteredData = data.data;
        this._configService.SnapshotList = data.data;
        //this.ShowAccessLevel();
      }
    });
  }

  openstudyDropdown() {
    this.Acrossdropdowncheck = false;
    this.studydropdown = !this.studydropdown;
  }

  studyNameclick(name: any) {
    this.studyname = name;
    this.Acrossname = "compare Across";
    this.studydropdown = false;
    this.AcrossDropdown = [];
  }

  AcrossNameclick(snapshot_name: any, sectionname: any, subsection: any) {
    this.snapshotselected = snapshot_name;
    this.sectionSelected = sectionname;
    this.subsectinselected = subsection;
    this._configService.snapshotSelectedName = this.snapshotselected;
    this._configService.selectedSection = this.sectionSelected;
    this._configService.selectedSubSection = this.subsectinselected;
    this.Acrossdropdowncheck = false;
    if (subsection == '')
      this.Acrossname = snapshot_name.toUpperCase() + ' : ' + sectionname;
    else
      this.Acrossname = snapshot_name.toUpperCase() + ' : ' + sectionname + ' : ' + subsection;
  }

  configurationSnapshot() {
    if (this.studyname == 'study Name') {
      let data: { client_name: string; study: string; configdata: any } = {
        client_name: this.ClientName,
        study: '',
        configdata: this.filteredData,
      };
      this.router.navigateByUrl('Snapshot/configuaration', { state: data });
    }
    else {
      let data: { client_name: string; study: string; configdata: any; snapshotselected: string, sectionselected: any; subsectionselected: any } = {
        client_name: this.ClientName,
        study: this.studyname,
        configdata: this.filteredData,
        snapshotselected: this._configService.snapshotSelectedName,
        sectionselected: this._configService.selectedSection,
        subsectionselected: this._configService.selectedSubSection
      };
      this.router.navigateByUrl('Snapshot/configuaration', { state: data });
    }
  }

  toggleStudies(clickedClient: any): void {
    // Close other clients if they are open
    this.popUpData.forEach((client: Client) => {
      if (client.ClientName !== clickedClient) {
        client.showStudies = false;
      }
      else {
        client.showStudies = true;
      }
    });

    // Toggle the studies for the clicked client
    // clickedClient.showStudies = !clickedClient.showStudies;
  }

  openacrossDropdown() {
    if (this.studyname != "study Name" && this.ClientName != '') {
      this.Acrossdropdowncheck = !this.Acrossdropdowncheck;
      let data = {
        ClientName: this.ClientName,
        SnapshotName: this.studyname
      }
      this._configCustomService.getCustomSnapshotWidgetLibrary(data).subscribe((r: any) => {
        let data = r?.Data
        let data1 = JSON.parse(data);
        this.AcrossDropdown = data1?.snapshotType;
        this._configService.AcrossDropdown = this.AcrossDropdown;
      },
        (error) => {
          // Handle any errors here
          console.error('Error:', error);
        }
      );
    }
  }

  navigateSnapshot() {
    if (this.ClientName === '' || this.studyname === '' || this.studyname === 'study Name') {
      this.router.navigateByUrl('landing');
    }
    else {
      this._configService
        .getClientStudyData({
          client_code: this.ClientName,
          snapshot_name: this.studyname,
        })
        .subscribe(async (b) => {
          var x = JSON.parse(b.body.Data);
          if (
            x != null &&
            x != undefined &&
            x != ''
          ) {
            let mainStudy = x.study_list[0].study_name;
            // let data: { client_code: string; study: string } = {
            //   client_code: this.selectedClientCode,
            //   study: this.selectedStudy,
            // };

            let data: { client_code: string; study: string; main_study: string, snapList: any, snapshotselected: string, sectionselected: any; subsectionselected: any } = {
              client_code: this.ClientName,
              study: this.studyname,
              main_study: mainStudy,
              snapList: this._configService.SnapshotList.filter((a: any) => a.ClientName == this.ClientName),
              snapshotselected: this._configService.snapshotSelectedName,
              sectionselected: this._configService.selectedSection,
              subsectionselected: this._configService.selectedSubSection
            };

            localStorage.setItem("snapshotselected_landing", this._configService.snapshotSelectedName);
            localStorage.setItem("sectionselected_landing", this._configService.selectedSection);
            localStorage.setItem("subsectionselected_landing", this._configService.selectedSubSection);


            if (x.product == "Standard") {
              this.router.navigateByUrl('Snapshot/snapshot-output', { state: data });
            }
            else if (x.product == "Custom") {
              this.router.navigateByUrl('Snapshot/custom-snapshot-output', { state: data });
            }

          }
          else {
            this.router.navigateByUrl('landing');
          }
        })
    }

  }
}
